const CustomSelectClassNames = {
  control: () => "form-control text-nowrap",
  placeholder: () => "text-muted"
};

const CustomSelectStyles = {
  control: (base: any) => ({
    ...base,
    '&:hover': {
      borderColor: "none"
    },
  }),
  input: (base: any) => ({
    ...base,
    padding: "0",
    margin: "0",
  }),
  menu: (base: any) => ({
    ...base,
    boxShadow: "0px 0px 50px 0px rgba(82, 63, 105, 0.1)",
    marginTop: "3px",
    marginBottom: "3px",
    border: "0 solid rgba(0, 0, 0, 0.15)",
    borderRadius: "0.475rem"
  }),
  menuList: (base: any) => ({
    ...base,
    boxShadow: "0px 0px 50px 0px rgba(82, 63, 105, 0.1)",
    border: "0 solid rgba(0, 0, 0, 0.15)",
    borderRadius: "0.475rem"
  }),
  menuPortal: (base: any) => ({
    ...base,
    boxShadow: "0px 0px 50px 0px rgba(82, 63, 105, 0.1)"
  }),
  option: (base: any, state: any) => ({
    ...base,
    padding: "0.5rem 1rem",
    fontSize: "0.95rem",
    backgroundColor: state.isSelected
      ? "#025D7D"
      : state.isFocused
      ? "#E0F4FA"
      : "transparent",
    color: state.isSelected
      ? "#FFFFFF"
      : state.isFocused
      ? "#025D7D"
      : "#5E6278",
    transition: "color 0.2s ease, background-color 0.2s ease"
  })
};

export { CustomSelectClassNames, CustomSelectStyles }
